import(/* webpackMode: "eager" */ "/srv/calcom/apps/web/app/global-error.tsx");
